// Admin configuration management
export const getDefaultAdminConfig = () => ({
  blog: {
    categories: [
      'AI in Software Development',
      'Prompt Engineering Best Practices',
      'Agile & AI',
      'Future Tech Trends',
      'Case Study Deep Dives'
    ],
    authors: [
      'Sarah Chen',
      'Michael Rodriguez',
      'Jennifer Walsh',
      'David Kim'
    ],
    statusOptions: [
      'Draft',
      'Published',
      'Featured',
      'Archived'
    ]
  },
  caseStudies: {
    industries: [
      'FinTech',
      'E-commerce',
      'Healthcare',
      'Education Technology',
      'SaaS',
      'Manufacturing',
      'Real Estate',
      'Entertainment'
    ],
    projectTypes: [
      'Web Application',
      'Mobile App',
      'API Development',
      'AI Integration',
      'System Migration',
      'Performance Optimization',
      'Security Audit',
      'Custom Software'
    ],
    technologies: [
      'React',
      'Node.js',
      'Python',
      'TypeScript',
      'Next.js',
      'Vue.js',
      'Express',
      'Django',
      'PostgreSQL',
      'MongoDB',
      'Redis',
      'AWS',
      'Docker',
      'Kubernetes',
      'GraphQL',
      'REST API',
      'Machine Learning',
      'AI/ML',
      'TensorFlow',
      'OpenAI',
      'Stripe',
      'Tailwind CSS',
      'Material-UI',
      'Firebase',
      'Supabase'
    ]
  }
});

export const getAdminConfig = () => {
  try {
    const config = localStorage.getItem('admin_config');
    return config ? JSON.parse(config) : getDefaultAdminConfig();
  } catch (error) {
    console.error('Failed to load admin config:', error);
    return getDefaultAdminConfig();
  }
};

export const saveAdminConfig = (config) => {
  try {
    localStorage.setItem('admin_config', JSON.stringify(config));
    return { success: true };
  } catch (error) {
    console.error('Failed to save admin config:', error);
    return { success: false, error: error.message };
  }
};

// Initialize default config if it doesn't exist
export const initializeAdminConfig = () => {
  const existing = localStorage.getItem('admin_config');
  if (!existing) {
    saveAdminConfig(getDefaultAdminConfig());
  }
};